import React from 'react';
import { Link } from 'react-router-dom';
import ParticlesBG from '../Shared/ParticlesBG';
import '../Assets/Stylesheets/Pages/ShopByIndustry.scss';

const ShopByIndustry = () => {
  return (
    <div className="shop-by-industry-page">
      <ParticlesBG />
      <div className="industry-hero">
        <div className="container">
          <h6>COMING SOON</h6>
          <h1>
            Shop by <span className="gradient-text">Industry</span>
          </h1>
          <p className="subtitle">
            We're building industry-specific marketing solutions tailored to your business needs.
            Check back soon!
          </p>
        </div>
      </div>

      <div className="industry-content">
        <div className="container">
          <div className="coming-soon-card">
            <div className="icon">🚀</div>
            <h2>Launching Soon</h2>
            <p>
              We're curating specialized marketing packages for different industries including:
            </p>
            <div className="industries-list">
              <div className="industry-badge">Restaurants & Food</div>
              <div className="industry-badge">E-commerce & Retail</div>
              <div className="industry-badge">Healthcare & Wellness</div>
              <div className="industry-badge">Real Estate</div>
              <div className="industry-badge">Professional Services</div>
              <div className="industry-badge">Technology & SaaS</div>
              <div className="industry-badge">Hospitality & Tourism</div>
              <div className="industry-badge">Education & Training</div>
            </div>
            <div className="cta-section">
              <p>In the meantime, explore all our services</p>
              <Link to="/marketing-services" className="cta-button">
                Browse All Services
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopByIndustry;

